export enum ProductNamesLabel {
  WHITE_LABEL = 'White label',
  CUSTOM_BRANDING = 'Custom branding',
  MODIFY_MENU = 'Modify Menu',
  USAGE_STATS = 'Usage stats',
  LIVE_TRANSLATIONS = 'Live Translations',
  REMEDIATION = 'Automated Remediation Technology (ART)',
  REMEDIATION_PLUS = 'Remediation Plus',
}

export enum ProductNamesLabelPaymentLink {
  WHITE_LABEL = 'White label',
  CUSTOM_BRANDING = 'Custom branding',
  MODIFY_MENU = 'Modify Menu',
  USAGE_STATS = 'Usage stats',
  LIVE_TRANSLATIONS = 'Live Translations',
  REMEDIATION = 'AI-Powered Accessibility Widget',
  REMEDIATION_PLUS = 'AI-Powered Accessibility Widget PRO Plus',
  SCANNING_AND_MONITORING = 'Scanning & Monitoring',
  PDF_AUTO_REMEDIATION = 'Auto PDF Remediation',
}
